import { AppContext } from "contexts/AppContext"
import { useContext } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { IS_ACTIVE_IMPERSONATION } from "./msalInstance";

const CheckAuth = ({ children }) => {
    const { userData, brandData, isSuperAdmin } = useContext(AppContext);
    const location = useLocation();
    const isDownForMaintenance = brandData && brandData.features && brandData.features.isDownForMaintenance;
    const shutDownAllBrands = brandData && brandData.features && brandData.features.shutDownAllBrands;
    if (!userData || !userData.UserID) {
        // Redirect user to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send user
        // along to that page after they login, which is a nicer user experience
        // than dropping user off on the home page.
        if (brandData?.features?.enableMsalAuth){
            const impersonation = localStorage.getItem(IS_ACTIVE_IMPERSONATION)
            const ssoPath = impersonation ? '/sso-impersonation' : '/sso'
            return <Navigate to={ssoPath} state={{ fromPage: location }}/>
        }

        if (!brandData?.isPublicClub){
            return <Navigate to="/login" state={{ fromPage: location }} />;
        }
    }
    if ((shutDownAllBrands || isDownForMaintenance) && !isSuperAdmin) {
        return <Navigate to="/maintenance" state={{ fromPage: location }} />; 
    }
    
    return children;
}

export default CheckAuth